import { render, staticRenderFns } from "./RecruitingProfileCard.vue?vue&type=template&id=a1ba0574&scoped=true&"
import script from "./RecruitingProfileCard.vue?vue&type=script&lang=ts&"
export * from "./RecruitingProfileCard.vue?vue&type=script&lang=ts&"
import style0 from "./RecruitingProfileCard.vue?vue&type=style&index=0&id=a1ba0574&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ba0574",
  null
  
)

export default component.exports